import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useRef, useEffect } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import {
  InputContainer,
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { weirflowVM } from './WeirFlowVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';

const WeirFlowComponent = (props) => {
  const vm = useRef(new weirflowVM(props)).current;
  useEffect(() => {
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);

  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="row formula-content">
        <InputContainer
          computeCallback={() => {
            vm.computeweirflow();
          }}
          printCallback={() => {
            vm.launchAndExport();
          }}
          isLoading={vm.isLoading}
          disableCompute={vm.disableComputeBtn}
          disablePrint={!vm.hasResults}
        >
          <h2 className='sections-heading'>General</h2>
          <ComboBox
            idAndName="weir-coefficient"
            label="Weir Coefficient (C)"
            aria-label="weir coefficient"
            valid={!vm.formValidation.weirCoefficient}
            value={vm.weirflowFormData.weirCoefficient}
            onChange={vm.handleWeirFlowForm}
            onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
            options={vm.entryOptions}
            errorMsg={''}
            required={true}
            className={`inlet-entry${vm.weirflowErrorClass('weirCoefficient')}`}
          />
          <Input
            label="Length of Weir (ft)"
            idAndName="length-of-weir"
            aria-label="length of weir"
            valid={!vm.formValidation.lengthOfWeir}
            value={vm.weirflowFormData.lengthOfWeir}
            type="number"
            onChange={(e) => {
              vm.handleWeirFlowForm(e);
            }}
            step={0.01}
            onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.weirflowErrorClass('lengthOfWeir')}
            min={0.01}
          />
          <Input
            label="Head on Weir (ft)"
            idAndName="head-on-weir"
            aria-label="head on weir"
            valid={!vm.formValidation.headOnWeir}
            value={vm.weirflowFormData.headOnWeir}
            type="number"
            onChange={(e) => {
              vm.handleWeirFlowForm(e);
            }}
            step={0.01}
            onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.weirflowErrorClass('headOnWeir')}
            min={0.01}
          />
        </InputContainer>
        <div className="col formula-information ">
          {vm.hasResults ? (
            <div className="row formula-results ">
              <ResultsContainer>
                <div className="col-auto result-value-group">
                  <div className="row">
                    <div className="col-auto result-label">Flow Q (cfs):</div>
                    <div className="col-auto result-value">{vm.weirFlowResults?.q}</div>
                  </div>
                </div>
              </ResultsContainer>
            </div>
          ) : (
            ''
          )}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>{vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                    Learn More
                    <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              <img className="water-flow-img" src={vm.image} alt={vm.hydraulicFormulaImageDescription} title={vm.formulaTitle} />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const WeirFlowFormula = observer(WeirFlowComponent);
